module.exports = __webpack_public_path__ + "static/media/banner_4-mobile.12d00481.jpg";